import { JSX } from 'react';
import { MultiColumnContainer, MultiColumnContainerProps } from '@ahc-digital/component-library';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C05MulticolumnCTAParams } from '../C05MulticolumnCTAs/C05MulticolumnCTA.types';
import { parseDroplinkParam } from 'src/shared/shared.service';
import { MULTI_COLUMN_CONTAINER } from 'src/shared/static';
import { RenderingProps } from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export function CreateMultiColumnContainerProps(
  props?: C47MulticolumnSplitterProps
): MultiColumnContainerProps {
  const numberOfColumns =
    (props?.params?.NumberOfColumns &&
      (parseDroplinkParam(props.params?.NumberOfColumns)?.value
        ?.value as MultiColumnContainerProps['numberOfColumns'])) ||
    '2';

  return {
    columnContents: props?.rendering ? (
      <Placeholder name={MULTI_COLUMN_CONTAINER} rendering={props.rendering} />
    ) : (
      <></>
    ),
    numberOfColumns: numberOfColumns,
  };
}

export type C47MulticolumnSplitterProps = RenderingProps<unknown, C05MulticolumnCTAParams>;

export const Default = (props?: C47MulticolumnSplitterProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <MultiColumnContainer
      {...CreateMultiColumnContainerProps(props)}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};
